import React from 'react';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import AppLayout from './components/layout/AppLayout';
import AuthLayout from './components/layout/AuthLayout';
import ParentLayout from './components/layout/ParentLayout';
import LoginPage from './pages/authentication/LoginPage';
import ForgotPasswordPage from './pages/authentication/ForgotPasswordPage';
import RegisterInitialize from './pages/authentication/RegisterInitialize';
import RegisterCompletePage from './pages/authentication/RegisterCompletePage';
import ParentHomeView from './pages/parents/ParentHomeView';
import PaymentsView from './pages/parents/payments/PaymentsView';
import ExecutePaymentView from './pages/parents/payments/ExecutePaymentView';
import CollectionsView from './pages/parents/collections/CollectionsView';
import ChildrenView from './pages/parents/children/ChildrenView';
import ChooseOrganizationView from './pages/organizations/ChooseOrganizationView';
import { useAuth } from './context/AuthContext';
import { CircularProgress, Box } from '@mui/material';

function ProtectedRoutes() {
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return <Outlet />;
}

function LoginRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading) return null;
  if (isAuthenticated) return <Navigate to="/parent/home" replace />;
  return <LoginPage />;
}

export default function App() {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<LoginRoute />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/register" element={<RegisterInitialize />} />
          <Route path="/register/:jwtToken" element={<RegisterCompletePage />} />
        </Route>

        <Route element={<ProtectedRoutes />}>
          <Route element={<ParentLayout />}>
            <Route path="/parent/home" element={<ParentHomeView />} />
            <Route path="/parent/payments/*" element={<PaymentsView />} />
            <Route path="/parent/execute-payment" element={<ExecutePaymentView />} />
            <Route path="/parent/collections/*" element={<CollectionsView />} />
            <Route path="/parent/children/*" element={<ChildrenView />} />
          </Route>

          <Route path="/choose-organization" element={<ChooseOrganizationView />} />
        </Route>

        <Route path="*" element={<Navigate to="/login" replace />} />
      </Route>
    </Routes>
  );
}
